import tns from "tiny-slider";

const widgets = document.querySelectorAll(".js-media-text");
[...widgets].forEach(widget => {
  const textContainer = widget.querySelector(".js-texts");
  const mediaContainer = widget.querySelector(".js-media");
  const navContainer = widget.querySelector(".js-nav");

  tns({
    navContainer,
    container: textContainer,
    mode: "gallery",
    controls: false,
    loop: false,
    touch: false
  });

  tns({
    navContainer,
    container: mediaContainer,
    mode: "gallery",
    controls: false,
    loop: false,
    touch: false
  });
});
